const types = {
    FETCH_FAILED: "ORDER_MODULES/FETCH_FAILED",
    FETCH_REQUEST: "ORDER_MODULES/FETCH_REQUEST",
    FETCH_SUCCESS: "ORDER_MODULES/FETCH_SUCCESS",
};

export default types;
